export default {
  "file": "_file_s9c6dt",
  "info": "_info_s9c6dt",
  "filename": "_filename_s9c6dt body-2",
  "filename--link": "_filename--link_s9c6dt",
  "size": "_size_s9c6dt body-2",
  "btn--link": "_btn--link_s9c6dt",
  "btn--file-icon": "_btn--file-icon_s9c6dt"
};